import(/* webpackMode: "eager", webpackExports: ["ClerkClientProvider"] */ "/app/apps/youlli_client/src/app/[lang]/clerk-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/youlli_client/src/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/youlli_client/src/app/[lang]/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_@babel+core@7.26.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_@babel+core@7.26.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
